import React from "react";

export const HPBar = ({ current, max, label = "HP", testId }) => {
  const pct = Math.max(0, Math.min(100, (current / max) * 100));
  const color =
    pct > 55 ? "#00E676" : pct > 25 ? "#FFEA00" : "#FF1744";

  return (
    <div className="w-full" data-testid={testId}>
      <div className="flex items-center justify-between mb-1">
        <span className="font-display text-xs sm:text-sm uppercase tracking-widest">
          {label}
        </span>
        <span className="font-display text-xs sm:text-sm">
          {Math.max(0, Math.round(current))} / {max}
        </span>
      </div>
      <div className="relative h-5 sm:h-6 w-full border-4 border-black bg-white overflow-hidden">
        <div
          className="h-full transition-[width] duration-500 ease-out"
          style={{
            width: `${pct}%`,
            background: `repeating-linear-gradient(45deg, ${color} 0 10px, ${shade(color, -15)} 10px 20px)`,
          }}
        />
      </div>
    </div>
  );
};

function shade(hex, pct) {
  const num = parseInt(hex.slice(1), 16);
  let r = (num >> 16) + Math.round(2.55 * pct);
  let g = ((num >> 8) & 0xff) + Math.round(2.55 * pct);
  let b = (num & 0xff) + Math.round(2.55 * pct);
  r = Math.max(0, Math.min(255, r));
  g = Math.max(0, Math.min(255, g));
  b = Math.max(0, Math.min(255, b));
  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, "0")}`;
}

export default HPBar;
